import { Flex, Tag } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { diffAccessRights } from '@constants';
import { colors } from '@theme';
import { getFullTimestamp } from '@utils';

import { actorName, channelLabel, eventAction, EventTone } from './journalDisplay';
import * as S from './styled';

type Props = {
  event: Schemas.MembershipEventRecordDto;
  targetName: string;
};

const TONE_COLOR: Record<EventTone, string> = {
  granted: colors.success,
  revoked: colors.red,
  changed: colors.primary,
};

const MembershipJournalEvent = ({ event, targetName }: Props) => {
  const action = eventAction(event.type);
  const { added, removed } = diffAccessRights(
    event.accessRightsBefore,
    event.accessRightsAfter
  );

  return (
    <S.Event vertical gap={8}>
      <Flex align="center" justify="space-between" gap={12}>
        <Tag color={TONE_COLOR[action.tone]} bordered={false}>
          {action.label}
        </Tag>
        <S.Date>{getFullTimestamp(event.createdAt)}</S.Date>
      </Flex>

      <S.Target>{targetName}</S.Target>

      <S.Meta>
        by {actorName(event.actor)}
        <S.Channel bordered={false}>{channelLabel(event.channel)}</S.Channel>
      </S.Meta>

      {(added.length > 0 || removed.length > 0) && (
        <S.Diff gap={6} wrap="wrap">
          {added.map((right) => (
            <Tag key={`+${right.key}`} color={colors.success} bordered={false}>
              + {right.label}
            </Tag>
          ))}
          {removed.map((right) => (
            <Tag key={`-${right.key}`} color={colors.red} bordered={false}>
              − {right.label}
            </Tag>
          ))}
        </S.Diff>
      )}
    </S.Event>
  );
};

export default MembershipJournalEvent;
